// import moment from 'moment'

export default {
  methods: {
    _startCreditCardPayment (OrderId, invoice, anonymousPayment, method,shippingProductCode,shippingProductsToAdd) {
      console.log('_startCreditCardPayment', OrderId, this.user.Email, invoice, {
        orderId: '' + OrderId,
        email: this.user.Email,
        invoice: '' + invoice,
        userCode: this.user.UserAccountCode,
        anonymousPayment: '' + anonymousPayment,
        newPaymentMethod: method && !method.Token,
        paymentMethodId: method ? method.Token : '',
        paymentMethodDescription: method && !method.Token ? method.Description : '',
        cardHolderName: method && !method.Token ? method.fullname : '',
        shippingProductCode:shippingProductCode,
        shippingProductsToAdd:shippingProductsToAdd
      })
      return this.$http.get('sales/buybasket', this.completeHttpParams({ headers: {
        orderId: '' + OrderId,
        email: this.user.Email,
        invoice: '' + invoice,
        userCode: this.user.UserAccountCode,
        anonymousPayment: '' + anonymousPayment,
        newPaymentMethod: '' + !!(method && !method.Token),
        paymentMethodId: method ? method.Token : '',
        paymentMethodDescription: method && !method.Token ? method.Description : '',
        cardHolderName: method && !method.Token ? method.fullname : '',
        shippingProductCode:shippingProductCode,
        shippingProductsToAdd:shippingProductsToAdd
      }})).then(response => response.body)
    },
    _startSatispayPayment (OrderId, invoice, anonymousPayment,shippingProductCode,shippingProductsToAdd) {
      console.log('_startSatispayPayment', OrderId, this.user.Email, invoice, {
        orderId: '' + OrderId,
        email: this.user.Email, invoice: '' + invoice,
        userCode: this.user.UserAccountCode,
        anonymousPayment: '' + anonymousPayment,
        shippingProductCode:shippingProductCode,
        shippingProductsToAdd:shippingProductsToAdd
      })
      return this.$http.get('sales/buybasketsatispay', this.completeHttpParams({ headers: {
        orderId: '' + OrderId,
        email: this.user.Email, invoice: '' + invoice,
        userCode: this.user.UserAccountCode,
        anonymousPayment: '' + anonymousPayment,
        shippingProductCode:shippingProductCode,
        shippingProductsToAdd:shippingProductsToAdd
      }})).then(response => response.body)
    },
    _closeFreeCart (OrderId, anonymousPayment) {
      console.log('_startFreePayment', OrderId, this.user.Email, {
        orderId: '' + OrderId,
        email: this.user.Email,
        userCode: this.user.UserAccountCode,
        anonymousPayment: '' + anonymousPayment
      })
      return this.$http.get('sales/buyfreebasket', this.completeHttpParams({ headers: {
        orderId: '' + OrderId,
        email: this.user.Email,
        userCode: this.user.UserAccountCode,
        anonymousPayment: '' + anonymousPayment
      }})).then(response => response.body)
    },
    _checkPaymentStatus (paymentId, orderId, loginToken) {
      return this.$http.get('sales/paymentstatus', this.completeHttpParams({ headers: { paymentId: '' + paymentId, orderId: '' + orderId, loginToken: loginToken || this.user.Token }})).then(response => response.body)
    },
    _getPaymentMethods () {
      /* return new Promise((resolve/* , reject * /) => {
        setTimeout(() => {
          resolve([{ id: '289274', Description: 'blablabla' }, { id: '8972345', Description: 'yadayada' }])
        }, 1500)
      }) */
      return this.$http.get('user/paymentmethods', this.completeHttpParams({ headers: { userCode: this.user.UserAccountCode }})).then(response => response.body)
    },
    _deletePaymentMethod (paymentMethodToken) {
      return this.$http.delete('user/deletepaymentmethod', this.completeHttpParams({ headers: { userCode: this.user.UserAccountCode, paymentMethodToken }})).then(response => response.body)
    }
  }
}